import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { MdEdit,  MdRemoveRedEye, MdPictureAsPdf } from 'react-icons/lib/md';

import { largeModalStyle } from '../../constants';
import { withAuth } from '../../actions/';
import { fetchBlueBookData, fetchContracts } from '../../actions/project_actions';
import BlueBookForm from './BlueBookForm';
import BlueBookViewForm from './BlueBookViewForm';

import { getDateValue } from '../../utils/date';

class ProjectBlueBook extends Component {
    
    constructor(props, context) {
        super(props, context);
        this.state = {
            blueBook: this.getNewBlueBook(),
            errors: { formValid:true, blueBookTrades: [] },
            contracts: [],
            isOpen: false,
            errMsg: false,

            currentPage: 1,
            itemsPerPage: 10
        };
        
        
        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.onModalClose = this.onModalClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.addChildRow = this.addChildRow.bind(this);
        this.handleChangeChildRow = this.handleChangeChildRow.bind(this);
        this.handleRegChange = this.handleRegChange.bind(this);
        this.getNewBlueBook = this.getNewBlueBook.bind(this);
        this.deleteChildRow = this.deleteChildRow.bind(this);
        this.handleValidation= this.handleValidation.bind(this);
        this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
        this.handleCPMChange = this.handleCPMChange.bind(this);
        this.handleChangeCPMtime = this.handleChangeCPMtime.bind(this);
        this.handleCPMChangeOut = this.handleCPMChangeOut.bind(this);
        this.handleChangeCPMtimeOut = this.handleChangeCPMtimeOut.bind(this);
        this.generatePDF = this.generatePDF.bind(this);

        this.handleClick = this.handleClick.bind(this);
        this.changeNumItemsShown = this.changeNumItemsShown.bind(this);
    }
    
    UNSAFE_componentWillMount(prevProps, prevState) {
        this.props.fetchBlueBookData(this.props.projectId);
        this.props.fetchContracts(this.props.projectId);
     
        if (prevState !==undefined && this.state.errors['formValid'] !== prevState.errors['formValid']) {
            this.handleValidation();  
        }
    }

    getNewBlueBook() {
        return {
            id: -1,
            projectid: this.props.projectId,
            dateVisit: '',
            dayOfWeek: '',
            contractRegNo: '',
            ccd: '',
            totalCCD: '',
            weather: '',
            tempAM: '',
            tempPM: '',
            siteCondition: '',
            comments: '',
            cpmTimeIn: '',
            cpmTimeOut: '',
            createBy: '',
            createdDate: '',
            blueBookTrades: [],
            notAtSite:false,
            formValid: true,
            disabled:false,
            timeIn: '',
            timeInHours: '',
            timeOut: '',
            timeOutHours: ''
        }
    }

    getNewBlueBookPTrade() {
        return {
            
            primeTrade: '',
            subTrade: '',
            noWorkers: '',
            hours: '',
            specialEquipment: '',
            locDescWorkInProgress: '',
            
        }
    }

    handleValidation() {
        
        let fields = this.state.blueBook;
        let errors = { blueBookTrades:[],formValid:true };
        let formIsValid = true;
        
        //this.setState( { errors: Object.assign({},errors) } );

        //Name
        if (!fields['dateVisit']) {
            errors['formValid'] = false;
            errors['dateVisit'] = 'required';
            formIsValid=false;
        }

        if (!fields['weather']) {
            errors['formValid'] = false;
            errors['weather'] = 'required';
            formIsValid=false;
        }

        if (!fields['tempAM']) {
            errors['formValid'] = false;
            errors['tempAM'] = 'required';
            formIsValid=false;
        }

        if (!fields['tempPM']) {
            errors['formValid'] = false;
            errors['tempPM'] = 'required';
            formIsValid=false;
        }

        if (!fields['siteCondition']) {
            errors['formValid'] = false;
            errors['siteCondition'] = 'required';
            formIsValid=false;
        }
        
        if (!fields['notAtSite']) {
            var reg = /\b((1[0-2]|0?[1-9]):([0-5][0-9]) ([AaPp][Mm]))/;
        
            if (!fields['cpmTimeIn']) {
                errors['formValid'] = false;
                errors['cpmTimeIn'] = 'required';
                formIsValid=false;
            }
            else
            {
                if(!fields['cpmTimeIn'].match(reg)){
                    errors['formValid'] = false;
                    errors['cpmTimeIn'] = '10:00 AM';
                    formIsValid=false;
                }  
            }
            if (!fields['cpmTimeOut']) {
                errors['formValid'] = false;
                errors['cpmTimeOut'] = 'required';
                formIsValid=false;
            }
            else
            {
                if(!fields['cpmTimeOut'].match(reg)){
                    errors['formValid'] = false;
                    errors['cpmTimeOut'] = '10:00 AM';
                    formIsValid=false;
                }          
            }
        }

        if(fields.blueBookTrades.length > 0)
        {
            
            
         
            for(let bt of fields.blueBookTrades)
            {
                let blueBookTrades= {};
                if (!bt['primeTrade'] && !bt['subTrade'] ) {
                    errors['formValid'] = false;
                    blueBookTrades['primeTrade'] = 'required';
                    blueBookTrades['subTrade'] = 'required';
                    formIsValid=false;
                }

                if (!bt['noWorkers'] ) {
                    errors['formValid'] = false;
                    blueBookTrades['noWorkers'] = 'required';
                    formIsValid=false;
                }

                if (!bt['hours'] ) {
                    errors['formValid'] = false;
                    blueBookTrades['hours'] = 'required';
                    formIsValid=false;
                }

                if (!bt['locDescWorkInProgress'] ) {
                    errors['formValid'] = false;
                    blueBookTrades['locDescWorkInProgress'] = 'required';
                    formIsValid=false;
                }
                
                errors.blueBookTrades.push(Object.assign({},blueBookTrades) );
            }
        }

        this.setState ( { errors : errors }, function() {
            console.log(this.state.errors.formValid);
        });

        if (formIsValid)
            this.setState({ errMsg: false });

        return formIsValid;
    }
    
    handleDateChange(name) {
        return (date) => {
    
            const blueBook = this.state.blueBook;
            blueBook[name] = date;
            if(date.trim() !== '') {
                var d = new Date(date);
                blueBook.dayOfWeek = this.props.weekday[d.getDay()];
            }
            else
                blueBook.dayOfWeek='';
            this.setState({ blueBook: blueBook });
            this.handleValidation();
        }
    }


    handleChange(field) {
        return (e) => {
            const blueBook = this.state.blueBook;
            blueBook[field] = e.target.value;
            this.setState({ blueBook: blueBook });
            this.handleValidation();
        };
    }

    handleChangeCPMtime(field) {
        return (e) => {
            const blueBook = this.state.blueBook;
            blueBook.timeInHours = e.target.value;
            blueBook.cpmTimeIn = blueBook.timeInHours  + ' ' + blueBook.timeIn ;
            this.setState({ blueBook: blueBook });
        };
    }
    
    handleCPMChange(option) {
        const blueBook = this.state.blueBook;
        blueBook.timeIn = option ? option.value : '';
        blueBook.cpmTimeIn = blueBook.timeInHours  + ' ' + blueBook.timeIn ;

        this.setState({ blueBook: blueBook });
    }

    handleChangeCPMtimeOut(field) {
        return (e) => {
            const blueBook = this.state.blueBook;
            blueBook.timeOutHours = e.target.value;
            blueBook.cpmTimeOut = blueBook.timeOutHours  + ' ' + blueBook.timeOut ;
            this.setState({ blueBook: blueBook });
        };
    }
    
    handleCPMChangeOut(option) {
        const blueBook = this.state.blueBook;
        blueBook.timeOut = option ? option.value : '';
        blueBook.cpmTimeOut = blueBook.timeOutHours  + ' ' + blueBook.timeOut ;
        this.setState({ blueBook: blueBook });
    }

    handleCheckBoxChange(field) {
        return (e) => {
            const blueBook = this.state.blueBook;
            blueBook[field] = e.target.checked;
            this.setState({ blueBook: blueBook });
        };
    }

    handleChangeChildRow(field, index) {
        return (e) => {

            const blueBook = this.state.blueBook;
            blueBook.blueBookTrades[index][field] = e.target.value;
            this.setState({ blueBook: blueBook });
            this.handleValidation();
        };
    }


    handleRegChange(option) {
        const blueBook = this.state.blueBook;
        blueBook.contractRegNo = option ? option.value : '';
        this.setState({ blueBook: blueBook });
    }

    onModalClose(blueBook, isOpen) {
        return (e) => {
            e.preventDefault();
            
            const errors = {blueBookTrades: [] };

            // eslint-disable-next-line no-empty-pattern
            for(let {} of blueBook.blueBookTrades)
            {
                errors.blueBookTrades.push(Object.assign({},this.getNewBlueBookPTrade())); 
            }
            
            if(blueBook.cpmTimeIn !== '' && blueBook.cpmTimeIn !== null)
            {
                blueBook.timeInHours = blueBook.cpmTimeIn.substr(0,blueBook.cpmTimeIn.indexOf(' '));
                blueBook.timeIn = blueBook.cpmTimeIn.substr(blueBook.cpmTimeIn.indexOf(' ')+1);
            }

            if(blueBook.cpmTimeOut !== '' && blueBook.cpmTimeOut !== null)
            {
                blueBook.timeOutHours = blueBook.cpmTimeOut.substr(0,blueBook.cpmTimeOut.indexOf(' '));
                blueBook.timeOut = blueBook.cpmTimeOut.substr(blueBook.cpmTimeOut.indexOf(' ')+1);
            }

            this.setState({ blueBook,errors, isOpen: isOpen, errMsg: false });
        };
    }


    addChildRow(e) {
    
        e.preventDefault();
        let childRow = {};
        const blueBook = this.state.blueBook;
        const errors = this.state.errors;
        childRow.blueBookId = blueBook.id;
        blueBook.blueBookTrades.push(childRow);
        errors.blueBookTrades.push(Object.assign({},this.getNewBlueBookPTrade()));
        this.setState({ blueBook: blueBook, errors: errors });

    }

    deleteChildRow(index) {
        return (e) => {
            e.preventDefault();
            const blueBook = this.state.blueBook;
            const errors = this.state.errors;
            blueBook.blueBookTrades.splice(index, 1);
            errors.blueBookTrades.splice(index, 1);
            this.setState({ blueBook: blueBook });
        };
    }

    

    handleSubmit(e) {
        if (e!==undefined)
            e.preventDefault();
        
        let retVal = this.handleValidation();
        
        if (retVal) {
            this.saveHandler();
            this.setState({ isOpen: false });
        }
        
        if (!retVal)
            this.setState({ errMsg: true });
    }

    saveHandler() {
        const { projectId } = this.props;
        const {blueBook } = this.state;
        
        let method = 'post';
        let url = `projects/${projectId}/bluebooks`;
        
        if (blueBook.id > 0) {
            method = 'put';
            url = `${url}/${blueBook.id}`;
        }

        return this.makePutOrPostRequest(blueBook, method, url);
    }

    makePutOrPostRequest(blueBook, method, url) {
        const { projectId } = this.props;

        blueBook.projectId = projectId;

        withAuth(
      { method, url, data: blueBook },
      () => {
          this.props.fetchBlueBookData(projectId);
        //this.closeModal();
        //alert('Saved');
      },
      this.errorHandler
    )
    }

    generatePDF(blueBookId)
  {
        return (e) => {
            e.preventDefault();
     
            const { projectId } = this.props;  
            const url = `/projects/${projectId}/bluebookreport/${blueBookId}`;
    //url = `https://localhost:44359/v1/projects/${projectId}/statusreport`;
    //window.open(url);
    //return;
            let method = 'get'; 
            let responseType = 'arraybuffer';
            withAuth(
      { method, url, responseType },
      (response) => {
       
        //this.closeModal();
        //alert(data.data);
          var data = response.data;
          var contentType = 'application/pdf';
          var blob = new Blob([data], { type: contentType }); 
          var downloadUrl= window.URL.createObjectURL(blob);
          window.open(downloadUrl,'_blank');
      },
      this.errorHandler
    )
        }
    }


    deleteBlueBook(blueBookId) {
      
      //alert();
   
      //this.props.blueBooks.splice(index,1);
      //this.props.dispatch(projectActions.deleteBlueBook(this.state.blueBook.id));

        const projectId = this.props.projectId;
      //const blueBookId = this.state.blueBooks[index].id

        const url = `/projects/${projectId}/bluebooks/${blueBookId}`;
        withAuth(
          { method: 'delete', url },
          () => {
              this.props.fetchBlueBookData(projectId);
          },
        this.errorHandler
      );
    }

    handleClick(event) {
        this.setState({
            currentPage: Number(event.target.id)
        });
    } 

    changeNumItemsShown(e) {
        if (e.target.value < 5 || e.target.value > this.props.blueBooks.length ) 
           // || ((e.target.value > this.props.blueBooks.length/2) && (this.state.currentPage)) )
            console.log(this.state.currentPage); 
        else {
            this.setState({ itemsPerPage: e.target.value });
             //   console.log(this.state.currentPage);
        }
    }

    render() {

        const { currentPage, itemsPerPage } = this.state;
        const { roleModules } = this.props.permissions.editPrivileges;

        // Logic for displaying items
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentBlueBooks = this.props.blueBooks.slice(indexOfFirstItem, indexOfLastItem);

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.props.blueBooks.length / itemsPerPage); i++) {
            pageNumbers.push(i);
        }

        const canEdit = roleModules !== null && roleModules.includes('Blue book') 
            ? true : false;

        return (

            <div id="blueBook" className="row-wide">

                <div className="col s12">
                    <h4 className="bar-bottom">Blue Book</h4>
                </div>

                <div className="col s12">
                    <div className="table-wrap">
                        <table>
                            <thead>
                                <tr>
                                    <th>Visit Date</th>
                                    <th>Day Of WK</th>
                                    <th>Weather</th>
                                    <th>Temp: AM</th>
                                    <th>Temp: PM</th>
                                    <th>Created By</th>
                                    <th>Created Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                { 
                                    currentBlueBooks.map((blueBook, index) => {
                                   
                                        let dt = new Date(getDateValue(blueBook.createdDate));
                                        dt = dt.setDate(dt.getDate() + 7);
                                        let currdt = new Date();
                                        blueBook.disabled = dt > currdt ? false : true

                                        return <tr key={index}>
                                            <td>{getDateValue(blueBook.dateVisit)}</td>
                                            <td>{blueBook.dayOfWeek}</td>
                                            <td>{blueBook.weather}</td>
                                            <td>{blueBook.tempAM}</td>
                                            <td>{blueBook.tempPM}</td>
                                            <td>{blueBook.createdBy}</td>
                                            <td>{getDateValue(blueBook.createdDate)}</td>
                                            <td>
                                            { dt > currdt && canEdit ?  
                                            <button onClick={this.onModalClose(blueBook, true)}>
                                                <span><MdEdit size={20} color='#8492a6' /></span>
                                            </button> 
                                            : <button onClick={this.onModalClose(blueBook, true)}>
                                                <span><MdRemoveRedEye size={28} color='#8492a6' /></span>                                             
                                              </button>
                                            
                                            }
                                            <button onClick={this.generatePDF(blueBook.id)}>
                                               <span><MdPictureAsPdf size={28} color='#8492a6' /></span>
                                            </button>
                                            
                                            {/*
                                                <button onClick={() => this.deleteBlueBook(blueBook.id)}>
                                                    <span><MdDelete size={22} color='#8492a6' /></span>
                                                </button>
                                            */}
                                            </td>
                                        </tr>
                                    })}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div id="sectionBtnsInfo">
                    { canEdit ?
                    <button className="btn-save" onClick={this.onModalClose(this.getNewBlueBook(), true)}>
                        Add
              </button> : null }
                </div>

                <Modal
                    isOpen={this.state.isOpen}
                    style={largeModalStyle}
                    contentLabel="Blue Book form">
                    <h1>Blue Book</h1>
                    {!this.state.blueBook.disabled && canEdit
                        ? <BlueBookForm blueBook={this.state.blueBook} handleChange={this.handleChange} handleDateChange={this.handleDateChange}
                            onSubmit={this.handleSubmit} addChildRow={this.addChildRow} handleChangeChildRow={this.handleChangeChildRow}
                            handleRegChange={this.handleRegChange} deleteChildRow={this.deleteChildRow} errors={this.state.errors}
                            handleCheckBoxChange={this.handleCheckBoxChange}
                            handleCPMChange={this.handleCPMChange}
                            handleChangeCPMtime={this.handleChangeCPMtime}
                            handleCPMChangeOut={this.handleCPMChangeOut}
                            handleChangeCPMtimeOut={this.handleChangeCPMtimeOut}
                            contracts={this.props.contracts}
                            timeIn={this.state.timeIn}
                            timeInHours={this.state.timeInHours}
                            timeOut={this.state.timeOut}
                            timeOutHours={this.state.timeOutHours}
                            errMsg={this.state.errMsg}
                        />
                        : <BlueBookViewForm blueBook={this.state.blueBook} contracts={this.props.contracts} />
                    }
                    <div className="modal-close" >
                        <span className="close" onClick={this.onModalClose(this.state.blueBook, false)}></span>
                    </div>
                </Modal>

                {pageNumbers.length > 1 &&
                    <div>
                        <div className="col s12">
                            <div className="controls margin-top-1">
                                <label className="label-pagination">Show</label>
                                <input type="number" value={itemsPerPage} onChange={this.changeNumItemsShown}
                                    min="5" max={this.props.blueBooks.length - 1} className="input-pagination" />
                                <span className="label-pagination">per page</span>
                            </div>
                        </div>

                        <div className="col s12">
                            <div className="pagination-blue-book">
                                <ul id="page-numbers">
                                    {pageNumbers.map(number => {
                                        return <li
                                            key={number}
                                            id={number}
                                            onClick={this.handleClick}
                                            className={currentPage === number ? 'active' : ''}
                                        >
                                            {number}
                                        </li>
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                }

            </div>
        );
    }

}

ProjectBlueBook.propTypes = {
    projectId: PropTypes.string.isRequired,
    permissions: PropTypes.object.isRequired,
    blueBooks: PropTypes.array.isRequired
};

ProjectBlueBook.defaultProps= {
    weekday: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday','Saturday'],
};

function mapStateToProps(state, ownProps) {
    return {
        blueBooks: state.projectsStore.blueBooks,
        contracts: state.projectsStore.contracts,
        projectId: ownProps.projectId,
        permissions: state.projectsStore.permissions,
    };
}

export default connect(mapStateToProps, { fetchBlueBookData, fetchContracts })(ProjectBlueBook);